import axiosInstance from "../../axios";

// Action Types
export const ORDER_LIST_REQUEST = 'ORDER_LIST_REQUEST';
export const ORDER_LIST_SUCCESS = 'ORDER_LIST_SUCCESS';
export const ORDER_LIST_FAILURE = 'ORDER_LIST_FAILURE';
export const ORDER_DETAILS_REQUEST = 'ORDER_DETAILS_REQUEST';
export const ORDER_DETAILS_SUCCESS = 'ORDER_DETAILS_SUCCESS';
export const ORDER_DETAILS_FAILURE = 'ORDER_DETAILS_FAILURE';
export const ORDER_CANCEL_REQUEST = 'ORDER_CANCEL_REQUEST';
export const ORDER_CANCEL_SUCCESS = 'ORDER_CANCEL_SUCCESS';
export const ORDER_CANCEL_FAILURE = 'ORDER_CANCEL_FAILURE';
export const ORDER_CLEAR_ERROR = 'ORDER_CLEAR_ERROR';

// Action Creators
export const orderListRequest = () => ({
    type: ORDER_LIST_REQUEST,
});

export const orderListSuccess = (orders) => ({
    type: ORDER_LIST_SUCCESS,
    payload: orders,
});

export const orderListFailure = (error) => ({
    type: ORDER_LIST_FAILURE,
    payload: error,
});

export const orderDetailsRequest = () => ({
    type: ORDER_DETAILS_REQUEST,
});

export const orderDetailsSuccess = (order) => ({
    type: ORDER_DETAILS_SUCCESS,
    payload: order,
});

export const orderDetailsFailure = (error) => ({
    type: ORDER_DETAILS_FAILURE,
    payload: error,
});

export const orderCancelRequest = () => ({
    type: ORDER_CANCEL_REQUEST,
});

export const orderCancelSuccess = (orderId) => ({
    type: ORDER_CANCEL_SUCCESS,
    payload: orderId,
});

export const orderCancelFailure = (error) => ({
    type: ORDER_CANCEL_FAILURE,
    payload: error,
});

export const orderClearError = () => ({
    type: ORDER_CLEAR_ERROR,
});

// Thunk Action Creators
export const fetchOrders = () =>
    async (dispatch) => {
        try {
            dispatch(orderListRequest());
            const response = await axiosInstance.get('order');
            console.log("ORDERS", response.data);

            if (response.data.status === 'Success') {
                dispatch(orderListSuccess(response.data.data || []));
            } else {
                dispatch(orderListFailure('Failed to fetch orders'));
            }
        } catch (error) {
            console.log(error);
            let errorMessage = 'Failed to fetch orders';

            if (error instanceof Error) {
                errorMessage = error.message;
            }

            dispatch(orderListFailure(errorMessage));
        }
    };

export const getOrderDetails = (orderId) =>
    async (dispatch) => {
        try {
            dispatch(orderDetailsRequest());
            const response = await axiosInstance.get(`order/${orderId}`);

            if (response.data.status === 'Success') {
                dispatch(orderDetailsSuccess(response.data.data));
            } else {
                dispatch(orderDetailsFailure('Failed to fetch order details'));
            }
        } catch (error) {
            console.log(error);
            let errorMessage = 'Failed to fetch order details';

            if (error instanceof Error) {
                errorMessage = error.message;
            }

            dispatch(orderDetailsFailure(errorMessage));
        }
    };

export const cancelOrder = (orderId) =>
    async (dispatch) => {
        try {
            dispatch(orderCancelRequest());
            const response = await axiosInstance.post(`orders/${orderId}/cancel`);

            if (response.data.status === 'Success') {
                dispatch(orderCancelSuccess(orderId));
            } else {
                dispatch(orderCancelFailure('Failed to cancel order'));
            }
        } catch (error) {
            console.log(error);
            let errorMessage = 'Failed to cancel order';

            if (error instanceof Error) {
                errorMessage = error.message;
            }

            dispatch(orderCancelFailure(errorMessage));
        }
    };


const initialState = {
    loading: false,
    orders: [],
    error: null,
    orderDetails: null,
    detailsLoading: false,
    cancelling: false
};

// Reducer
const orderReducer = (state = initialState, action) => {
    switch (action.type) {
        case ORDER_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case ORDER_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                orders: action.payload,
                error: null
            };

        case ORDER_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case ORDER_DETAILS_REQUEST:
            return {
                ...state,
                detailsLoading: true,
                orderDetails: null,
                error: null
            };

        case ORDER_DETAILS_SUCCESS:
            return {
                ...state,
                detailsLoading: false,
                orderDetails: action.payload,
                error: null
            };

        case ORDER_DETAILS_FAILURE:
            return {
                ...state,
                detailsLoading: false,
                error: action.payload
            };

        case ORDER_CANCEL_REQUEST:
            return {
                ...state,
                cancelling: true,
                error: null
            };

        case ORDER_CANCEL_SUCCESS:
            return {
                ...state,
                cancelling: false,
                orders: state.orders.map(order =>
                    order.id === action.payload
                        ? { ...order, status: 'CANCELLED' }
                        : order
                ),
                orderDetails: state.orderDetails &&
                Array.isArray(state.orderDetails) &&
                state.orderDetails.length > 0 &&
                state.orderDetails[0].id === action.payload
                    ? state.orderDetails.map(item => ({ ...item, status: 'CANCELLED' }))
                    : state.orderDetails,
                error: null
            };

        case ORDER_CANCEL_FAILURE:
            return {
                ...state,
                cancelling: false,
                error: action.payload
            };

        case ORDER_CLEAR_ERROR:
            return {
                ...state,
                error: null
            };

        default:
            return state;
    }
};

export default orderReducer;